const PropTypes = require('prop-types');
const React = require('react');
const UrlHelpers = require('components/shared/url_helpers.js');
const EmbeddedListing = require('./embedded_listing.jsx');

class Embeds extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      embeds: {},
    };
  }

  componentDidMount() {
    this.fetchEmbeds();
  }

  fetchEmbeds() {
    Reverb.APIRequest.V3.get(
      UrlHelpers.messageEmbedsPath(this.props.messageId)
    ).done((response) => {
      this.setState({ embeds: response });
    });
  }

  get listings() {
    return this.state.embeds.listings;
  }

  renderListingEmbeds() {
    return this.listings.map((listing) =>
      <EmbeddedListing listing={listing} key={`listing-${listing.id}`} />
    );
  }


  render() {
    if (!this.listings) { return null; }

    return (
      <div>
        {this.renderListingEmbeds()}
      </div>
    );
  }
}


Embeds.propTypes = {
  messageId: PropTypes.number.isRequired,
};

module.exports = Embeds;



// WEBPACK FOOTER //
// ./javascripts/components/conversations/embeds.jsx